import styled from 'styled-components';

export const Footer = styled.div`
  position: relative;
  margin-top: 97px;
  box-sizing: border-box;
  background-color: transparent;
`;

export const Container = styled.div`
  position: relative;
  padding-bottom: 42px;
  box-sizing: border-box;
  > .bg {
    position: absolute;
    z-index: -1000;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  > .left-top-bg {
    position: absolute;
    display: block;
    z-index: -1000;
    top: 0;
    left: 0;
    transform: translateY(-100%);
  }
  > .right-top-bg {
    position: absolute;
    display: block;
    z-index: -1000;
    top: 0;
    right: 0;
    transform: translateY(-100%);
  }
  > .left-top-decoration {
    position: absolute;
    display: block;
    z-index: -1000;
    top: 20px;
    left: 0;
    transform: translateY(-100%);
  }
  > .right-top-decoration {
    position: absolute;
    display: block;
    z-index: -1000;
    top: 43px;
    right: 18px;
    transform: translateY(-100%);
  }
  > .left-bottom-decoration {
    position: absolute;
    display: block;
    z-index: -1000;
    bottom: 12px;
    left: 10px;
  }
  > .right-bottom-decoration {
    position: absolute;
    display: block;
    z-index: -1000;
    bottom: 14px;
    right: 18px;
  }
`;

export const Content = styled.div`
  position: relative;
  text-align: center;
  /* height: 642px; */
  /* padding-top: 97px; */
  //height: 452px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
`;

export const Header = styled.div`
  height: 130px;
`;

export const SplitLine = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin-left: ${props => props.marginLeft};
  margin-right: ${props => props.marginRight};
`;

export const Menu = styled.div`
  height: 180px;
`;

export const NavFloor = styled.div``;
